<template>
    <div 
        style="z-index:300"  
        class="footer-section w-100" 
        :class="{'position-absolute': positionSetted, 'inset-shadow': isEcommercePlatform || $route.name === 'pricing'}"
    >
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <footer class="footer" :class="{'ecommerce-footer': isEcommercePlatform}">
                        <div class="footer__content" :class="{'inset-shadow': isEcommercePlatform}">
                            <router-link 
                                :to="user ? '/browse': '/'" 
                                class="d-flex" 
                                id="cp-footer-logo"
                            >
                                <Icon icon="footer-logo"/>
                            </router-link>
                            <div v-if="!isEcommercePlatform" class="footer__items">
                                <router-link to="/privacypolicy" id="privacy-policy-footer" class="footer__item">
                                    Privacy Policy
                                </router-link>
                                <router-link to="/termsofuse" class="footer__item" id="terms-of-use-footer">
                                    Terms of Use
                                </router-link>
                                <a 
                                    v-if="!isEcommercePlatform"
                                    @click="toCrosspromHelp" 
                                    href="https://help.crossprom.com/" 
                                    class="footer__item" 
                                    target="_blank"
                                    id="help-footer"
                                >
                                    Help
                                </a>
                            </div>
                            <a id="footer-mail" @click="mailTo('team@crossprom.com')" class="footer__item d-flex align-items-center">
                                <Message class="mr-2"/>
                                team@crossprom.com
                            </a>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { FooterLogo, Message } from './Icons'
import Icon from '@/components/Theme/Icon'
export default {
    name: "Footer",
    components: {
        FooterLogo, 
        Message,
        Icon
    },
    data() {
        return {
            mobileDevices: false
        }
    },
    computed: {
        ...mapState([
            'user',
            'stripePublishableKey',
        ]),
        ...mapGetters([
            'isEcommercePlatform'
        ]),
        loggedIn () {
            return this.user && this.user.uid
        },
        positionSetted() {
            return (this.isEcommercePlatform && !this.mobileDevices) || (!this.isEcommercePlatform && !this.mobileDevices)
        }
    },
    mounted: function() {
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth()
        })
    },
    methods: {
        getWindowWidth(event) {
            this.mobileDevices = document.documentElement.clientWidth < 768
            this.$emit('toggleFooter', this.mobileDevices)
        },
        mailTo: function(mail) {
            window.location.href = `mailto:${mail}`
        },
        toCrosspromHelp(){
            this.$ga.event('Help', 'Click', `
                LoggedIn: ${!!this.loggedIn},
                Location: Footer
            `);

            this.$sendMixpanelEvent('Help Clicked', {
                'Logged In': !!this.loggedIn,
                'Link Location': 'Footer'
            });
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },
}
</script>

<style scoped lang="scss">
$footer_gap: 24px;
$footer_gap_mob: 20px;
$border_color: #CBD5E0;
$footer_text_color: #718096;
$footer_text_hover_color: #333333;
$footer_font_size: 14px;
$footer_line-height: 20px;
$footer_items_gap: 0 36px;
$footer_items_gap_mob: 12px 0;
$footer_item_gap: 32px;
$transform: all 0.2s ease;
.footer-section {
    bottom: 0;
    background: white;
    &.inset-shadow {
        box-shadow: inset 0px 1px 0px #E2E8F0;
    }
}   
.footer {
    height: 60px;
    @media (max-width: 768px) {
        height: 180px;
    }
    &.ecommerce-footer {
        @media (max-width: 768px) {
            height: 100px !important;
        }
        .footer__content {
            #footer-mail {
                margin-left: 32px;
                @media (max-width: 768px) {
                    margin-left: 0;
                }
            }
        }
    }
    &__content {
        display: flex;
        align-items: center;
        height: 100%;
        
        
    
        @media (max-width: 768px) {
            flex-direction: column;
            padding: 20px 0 12px;
            justify-content: space-between;
        }
    }
    &__items {
        padding: $footer_items_gap;
        margin: 0 $footer_item_gap;
        border-left: 1px solid $border_color;
        border-right: 1px solid $border_color;
        @media (max-width: 768px) {
            padding: $footer_items_gap_mob;
            margin-top: 16px;
            border: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            &::before,
            &::after {
                content: '';
                width: 40px;
                height: 1px;
                background: $border_color;
                position: absolute;
                left: 0;
                right: 0;
                margin: auto;
            }
            &::before {
                top: 0;
            }
            &::after {
                bottom: 0;
            }
        }
    }
    a#{&}__item {
        color: $footer_text_color;
        transform: $transform;
        position: relative;
        &:hover {
            color: $footer_text_hover_color
        }
        &:not(:last-child) {
            margin-right: $footer_item_gap;
            @media (max-width: 768px) {
                margin-right: 0;
            }
        }
        @media (max-width: 768px) {
            &:not(:first-child) {
                margin-top: $footer_gap_mob;
            }
        }

    }
}
</style>

